<template>
    <div>
        <div class="loading-spinner" v-if="isLoading">
            <base-spinner></base-spinner>
        </div>
        <!--검색 조건 -->

        <!-- 항목 테이블 -->
        <div class="tbl_wrap" v-if="itemlists">
            <div class="search_part">
                <button @click="getBuyItems()">새로고침</button>               
                <span>금요일 일괄 배송으로 환불신청은 <strong>목요일</strong>까지만 가능합니다.</span>
            </div>
            <table class="tbl">
                <colgroup>
                    <col style="width:5%" />
                    <col style="*" />
                    <col style="width:15%" />
                    <col style="width:10%" />
                    <col style="width:10%" />
                    <col style="width:10%" />
                    <col style="width:10%" />                   
                </colgroup>
                <thead>
                    <tr>
                        <th>번호</th>
                        <th>아이템</th>
                        <th>가격</th>
                        <th>구매수량</th>                       
                        <th>구매날짜</th>
                        <th>상태</th>
                        <th>환불신청</th>
                    </tr>
                </thead>
                <tbody>                   
                    <template v-if="itembuylists.data.length ===0">
                        <tr><td colspan="8">구매한 상품이 없습니다.</td></tr>
                    </template>
                    <template v-else>
                        <tr v-for="(item, index) in itembuylists.data" :key="index" :class="{'isUseable':item.count>0}">
                            <td>{{itembuylists.total - itembuylists.from + 1 - index}}</td>
                            <td>
                                <router-link :to="`/main/goods/view/${item.goods_id}`">{{item.goods_title}}</router-link>
                            </td>
                            <td class="price">
                                <template v-if="item.goods_price > 0">
                                    {{addComma(item.goods_price)+' 원'}}
                                </template>
                                <template v-else>
                                    {{addComma(Math.abs(item.goods_point))+' P'}}
                                </template>
                            </td>
                            <td>{{item.count}}</td>                           
                            <td><display-time :time="item.created_at"/></td>
                            <td :class="{'isActive':item.state===1}">                                                             
                                {{itemState[item.state]}}                               
                            </td>
                            <td>                               
                                <div class="btn_use" v-if="ckday() && item.state===1 ">
                                    <base-button-sm mode="orange" @click="refund(item.id)">환불신청</base-button-sm>
                                </div>
                            </td>
                        </tr>
                    </template>

                </tbody>
            </table>
           
            <paginate store="goods" collection="goodsBuy"  @paging="getBuyItems"/>
        </div>

        <!-- 환불신청 -->
        <base-dialog :show="popdialog" title="환불신청" @close="popClose()" apply="환불신청" @apply="confirmRefund()">
            <div class="dialog_box">
                <div class="item_title">
                <h1>[{{refundGoods.goods_title}} ] 상품구매 취소</h1>  
                <span>상품구매 취소는 월요일 ~ 목요일 까지만 가능합니다.</span>           
                </div>
                <div class="input_area">   
                    
                    <div class="description danger">
                        해당상품의 구매취소 요청 하시겠습니까?                              
                    </div>               
                </div>               
            </div>
        </base-dialog>
    </div>
</template>
<script>
import { myGoodsBuy } from '@/components/mixins/pages/myGoodsBuy.js'
export default {
    name:'myGoodsBuy',
    mixins:[ myGoodsBuy],  
   
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/table';
.isUseable{
     cursor:pointer;
    td{color:black !important;}
    .remain{background:#0d4e7c;border-radius:5px; padding:5px 10px;color:white;font-weight:bold}
    .isActive{
        span{color:red;font-weight:bold}
    }
}
.btn_use{line-height:20px;
    button{margin:0}
}
.price{
    font-weight: bold;
}
.search_part{
    display: flex;
    justify-content: space-between;
    button{cursor: pointer;}
}
</style>
